import { render, staticRenderFns } from "./PlantLoader.vue?vue&type=template&id=5ec384d5&scoped=true"
import script from "./PlantLoader.vue?vue&type=script&lang=js"
export * from "./PlantLoader.vue?vue&type=script&lang=js"
import style0 from "./PlantLoader.vue?vue&type=style&index=0&id=5ec384d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec384d5",
  null
  
)

export default component.exports